import React from 'react';
import { Drawer, Button, Panel, Divider, Tag, Stack } from 'rsuite';
import { Icon } from '@rsuite/icons';
import { MdPerson } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

const ExceptionalDetailsDrawer = ({ open, onClose, data }) => {
  const getStatusColor = status => {
    switch (status) {
      case 'accepted':
        return 'green';
      case 'pending':
        return 'yellow';
      case 'Reject':
        return 'red';
      default:
        return 'grey';
    }
  };
  const { t } = useTranslation();

  return (
    <Drawer backdrop="static" size="sm" placement="right" open={open} onClose={onClose}>
      <Drawer.Header>
        <Drawer.Title>{t('Exceptional Home Office Request Details')}</Drawer.Title>
        <Drawer.Actions>
          <Button onClick={onClose} appearance="primary">
            {t('Close')}
          </Button>
        </Drawer.Actions>
      </Drawer.Header>

      <Drawer.Body>
        <Panel bordered style={{ padding: '16px', borderRadius: '8px' }}>
          <Stack spacing={10}>
            <Icon as={MdPerson} style={{ fontSize: '25px', color: '#3498ff' }} />
            <h5 style={{ margin: 0, color: '#333' }}>
              {`${data?.idSender?.firstname || ''} ${data?.idSender?.lastname || ''}`}
            </h5>
          </Stack>

          <Divider />

          <div style={{ padding: '0 10px', lineHeight: 1.8 }}>
            {[
              {
                label: t('Status'),
                value: (
                  <Tag color={getStatusColor(data?._id?.status)}>
                    {t(data?._id?.status) || t('Unknown')}
                  </Tag>
                )
              },
              {
                label: t('Registration number'),
                value: data?.idSender?.registrationNumber || 'N/A'
              },
              {
                label: t('Email'),
                value: data?.idSender?.Email || 'N/A'
              },
              {
                label: t('Days Requested'),
                value:
                  data?.operations
                    ?.map(op => {
                      const startDate = new Date(op.date_debut);
                      const endDate = new Date(op.date_fin);

                      const formattedStartDate = startDate.toLocaleDateString();
                      const formattedEndDate = endDate.toLocaleDateString();
                      if (formattedStartDate === formattedEndDate) {
                        return formattedStartDate;
                      } else {
                        return `${formattedStartDate} to ${formattedEndDate}`;
                      }
                    })
                    .join(', ') || 'N/A'
              },
              {
                label: t('Created at'),
                value: data?._id?.createdAt ? new Date(data._id.createdAt).toLocaleString() : 'N/A'
              },
              {
                label: t('Receiver'),
                value: `${data?.idReciever?.firstname || ''} ${data?.idReciever?.lastname || 'N/A'}`
              },
              {
                label: t('User Notifications'),
                value:
                  data?.UserNotif?.length > 0
                    ? data.UserNotif.map(user =>
                        typeof user === 'string'
                          ? user
                          : `${user?.firstname || ''} ${user?.lastname || 'Unknown User'}`
                      ).join(', ')
                    : 'N/A'
              },
              {
                label: t('Comments'),
                value: data?._id?.commentUser || 'N/A'
              }
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '8px 0',
                  borderBottom: index < 3 ? '1px solid #f0f0f0' : 'none'
                }}
              >
                <strong>{item.label}:</strong>
                <span>{item.value}</span>
              </div>
            ))}
          </div>
        </Panel>
      </Drawer.Body>
    </Drawer>
  );
};

export default ExceptionalDetailsDrawer;
